import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ReduxProvider from './providers/ReduxProvider';
import AppRoute from './routes/AppRoute';
import Snackbar from './components/common/SnackbarMessage';
import { SettingsProvider } from './providers/SettingsProvider';

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import TokenProvider from './providers/TokenProvider';
import { AdProvider } from './providers/AdProvider';
import { ChatHistoryProvider } from './providers/ChatSessionProvider';


const App = () => {
    return (
        <SettingsProvider>
            {/* <ReduxProvider> */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TokenProvider>
                    <AdProvider>
                        <ChatHistoryProvider>
                            <Router>
                                <Routes>
                                    <Route path='*' element={<AppRoute />} />
                                </Routes>
                            </Router>
                            <Snackbar />
                        </ChatHistoryProvider>
                    </AdProvider>
                </TokenProvider>
            </LocalizationProvider>
            {/* </ReduxProvider> */}
        </SettingsProvider>
    )
}

export default App;